























import { computed, defineComponent } from "@vue/composition-api";
import { QuickTip } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "QuickTipsItem",
  components: { BaseIconButton, BaseIcon },
  props: {
    item: { type: Object as () => QuickTip, required: true },
    showCloser: { type: Boolean },
  },
  setup(props) {
    const iconColor = computed(() => `var(--palette-${props.item.color ?? "primary"})`);
    const borderColor = computed(() => `rgba(var(--palette-${props.item.color ?? "primary"}-rgb), 0.3)`);
    return {
      iconColor,
      borderColor,
    };
  },
});
